import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkAccess(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkAccess(route);
  }

  private checkAccess(route: ActivatedRouteSnapshot) {
    const requiredPermission = route.data['auth'];

    if (!this.authService.logginUser) {
      this.router.navigate(['/admin/login']);
      return false;
    }

    if (!requiredPermission || this.authService.is_main_store_login) {
      return true;
    }

    return this.authService.authPermission.pipe(
      take(1),
      map((permissions) => {
        const hasPermission = permissions.includes(requiredPermission);

        if (!hasPermission) {
          this.router.navigate(['/app/dashboard']);
        }

        return hasPermission;
      })
    );
  }
}
